//@commons
const actionTypes = require('constants/actionTypes');
const { APIPost } = require('utilities/APIRequestHelper');
const { CARD_ECARD, CARD_OPENYOUNG } = require('constants/index');

const eCardInformationRequest = () => ({
    type: actionTypes.ECARD_INFORMATION_REQUEST
});

const eCardInformationSuccess = (cardId, data) => ({
    type: actionTypes.ECARD_INFORMATION_SUCCESS,
    payload: {
        cardId,
        data: data.datosTarjeta
    }
});

const eCardInformationFailure = (error) => ({
    type: actionTypes.ECARD_INFORMATION_FAILURE,
    payload: {
        error: error.description
    }
});

const setCard = (cardId, cardBalance, cardType) => ({
    type: actionTypes.CARD_CHARGE_SET_CARD,
    payload: { cardId, cardBalance, cardType }
});

const getECardInformation = (cardId) => (dispatch, getState) => {
    const immCard = getState().cards.getIn(['byId', cardId]);

    const requestData = {
        query: {
            producto: immCard.getIn(['contract', 'product']),
            numeroContrato: immCard.getIn(['contract', 'number']),
            numTarjeta: immCard.get('number')
        }
    };

    dispatch(eCardInformationRequest());
    return APIPost({
        dispatch,
        endpoint: 'getECardInformation',
        params: requestData
    })
    .then(response => {
        const cardBalance = response.datosTarjeta.saldoActualPrepago.importe;
        const cardType = immCard.get('isOpenYoung') ? CARD_OPENYOUNG : CARD_ECARD;
        dispatch(setCard(cardId, cardBalance, cardType));
        dispatch(eCardInformationSuccess(cardId, response));
    })
    .catch((response) => dispatch(eCardInformationFailure(response.error)));
};

module.exports = {
    getECardInformation
};
